module.exports = __webpack_public_path__ + "img/location_on-blue-18dp.3971f5df.svg";